import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'
import Con from '../../static/config.json'

Vue.use(Vueaxios, axios)
const URL = Con.URL
// const URL = '/api/'
export default {
  getConfig (success, error) {
    Vue.axios.get(URL + 'config').then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  UpdateConfig (obj, header, success, error) {
    Vue.axios.post(URL + 'config', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getMenus (header, success, error) {
    Vue.axios.get(URL + 'menu', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  regisLine (obj, success, error) {
    Vue.axios.put(URL + 'line', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getTokenLine (obj, success, error) {
    Vue.axios.post(URL + 'line', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getHomeAll (success, error) {
    Vue.axios.get(URL + 'home/all').then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  UploadFile (obj, header, success, error) {
    Vue.axios.post(URL + 'upload', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getZoneAll (success, error) {
    Vue.axios.get(URL + 'homezone/all').then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/service.js